"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ = require("..");

var styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    border: "1px solid ".concat(_.colors.blue),
    borderRadius: '3px',
    height: '35px',
    width: 'fit-content'
  }
};
var _default = styles;
exports["default"] = _default;